import React from 'react';
import i18n from 'i18next';
import { ImageView } from '@ringcentral/rcv-ui/src/components/ImageView';
import { useBrandConfig } from '@low/utils/get-brand-config';

export const Logo = () => {
    const getBrandConfig = useBrandConfig();
    const mainLogoUrl = getBrandConfig(['assets', 'mainLogoUrl']);

    return (
        <div className='colored-logo'>
            <ImageView src={mainLogoUrl} title={i18n.t('global.WEB_PAGE_TITLE')} />
        </div>
    );
};
